// Utility function to fetch data with retry mechanism
export async function fetchWithRetry(url, options = {}, maxRetries = 3, retryDelay = 1000) {
  let retries = 0;
  let lastError;

  while (retries < maxRetries) {
    try {
      const response = await fetch(url, options);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      lastError = error;
      retries++;
      console.log(`Fetch attempt ${retries} failed for ${url}. Retrying...`);

      if (retries < maxRetries) {
        // Wait before retrying (with exponential backoff)
        await new Promise(resolve => setTimeout(resolve, retryDelay * Math.pow(2, retries - 1)));
      }
    }
  }

  console.error(`All ${maxRetries} fetch attempts failed for ${url}:`, lastError);
  throw lastError;
}
